import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';

// Styles
import styles from './styles.js';

const initialMap = {
    0: styles.eucalyptus,
    1: styles.islamicGreen,
    2: styles.chileanFire,
    3: styles.endeavour,
    4: styles.persianPink,
    5: styles.gigas,
    6: styles.purpleHeart,
    7: styles.darkSpringGreen,
    8: styles.persianGreen,
    9: styles.dodgerBlue,
    10: styles.jordyBlue,
    11: styles.hollywoodCerise,
    12: styles.eminence,
    13: styles.limerick
};

class Initials extends Component {
    static propTypes = {
        initials: PropTypes.string.isRequired
    }

    render() {
        const { initials } = this.props;
        let colourKey = Math.ceil((initials.charAt(0).charCodeAt(0) - 65) / 2);
        if (colourKey > 13) {
            colourKey = 0;
        }
        const initialStyle = initialMap[colourKey];
        return (
            <div className={css(styles.text, initialStyle)}>
                {initials}
            </div>
        );
    }
}

export default Initials;



// WEBPACK FOOTER //
// ./src/components/Header/Nav/AvatarSection/Avatar/Initials/Initials.jsx